import React, { Component } from 'react';

import Avatar from '@material-ui/core/Avatar';

import autoBind from 'react-autobind';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  main: {
    backgroundColor: '#f9f9f9',
    textAlign: 'left',
  },
  foodieTip: {
    padding: '1px 20px 20px 20px',
  },
  subTitle: {
    fontSize: '1.3em',
  },
  count: {
    padding: '20px',
    paddingTop: '0',
    marginTop: '-25px',
  },
  avatarContainer: {
    textAlign: 'right',
    marginTop: '-35px',
  },
  avatar: {
    width: '50px',
    height: '50px',
    float: 'right',
  },
  tip: {
    marginTop: '50px',
    marginBottom: '30px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.089375rem',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
});

const FoodieTip = ({ foodieTip = {}, classes }) => {
  const owner = foodieTip.owner ? foodieTip.owner : {};
  const ownerName = owner.displayName ? owner.displayName : owner.name;
  const checkProfileHasHome = owner.userProfile ? owner.userProfile : [];
  const ownerHome = checkProfileHasHome.hometown
    ? checkProfileHasHome.hometown.name
    : '';
  let tips = foodieTip.tip.split('.').map((tip, i) => (tip ? tip : ''));
  return (
    <div>
      <span>
        <Typography variant="subtitle2">
          {ownerName} {ownerHome ? ' | ' : ' '}
          {ownerHome}
        </Typography>
        <hr />
        <div className={classes.avatarContainer}>
          <Avatar
            className={classes.avatar}
            alt={ownerName}
            src={owner.profilePic ? owner.profilePic.uri : '/icons/user.png'}
          />
        </div>
      </span>
      <ul className={classes.tip}>
        {tips.map((ftip, i) =>
          ftip === '' ? '' : <li key={'ftips' + i}>{ftip}</li>
        )}
      </ul>
    </div>
  );
};

class CuratorsTip extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { expanded: false };
  }
  expand() {
    this.setState({ expanded: true });
  }
  minimize() {
    this.setState({ expanded: false });
  }
  render() {
    const { classes, tips = [] } = this.props;
    let data = tips;
    let remainingCont = '';

    if (data.length > 2) {
      remainingCont = <span onClick={this.expand}>MORE...</span>;
    }
    const moreTips = [];
    if (this.state.expanded === true && data.length > 2) {
      for (var i = 2; i < data.length; i++) {
        if (data[2].owner.displayName === data[3].owner.displayName) {

        }
        else
        {
          moreTips.push(
            <FoodieTip classes={classes} key={'tip' + i} foodieTip={data[i]} />
          );
        }

      }
      remainingCont = <span onClick={this.minimize}>LESS...</span>;
    }
    return (
      <div>
        <div className={classes.main}>
          <div className={classes.foodieTip}>
            {data.length > 0 ? (
              <Typography variant="body2">PUNDIT TIPS</Typography>
            ) : (
                ''
              )}

            <br />
            {data.length > 0 ? (
              <FoodieTip classes={classes} key={'tip0'} foodieTip={data[0]} />
            ) : (
                ''
              )}
            {data.length > 1 ? (
              <FoodieTip classes={classes} key={'tip1'} foodieTip={data[1]} />
            ) : (
                ''
              )}
            {moreTips}
          </div>
          <div className={classes.count}>{remainingCont}</div>
        </div>
      </div>
    );
  }
}

CuratorsTip.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratorsTip);
